import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12f02a5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "dialog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "エンジン設定", -1))
const _hoisted_3 = { class: "dialog-form-area option-list" }
const _hoisted_4 = { class: "option" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-name" }, "エンジン名", -1))
const _hoisted_6 = { class: "option-unchangeable" }
const _hoisted_7 = { class: "option" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-name" }, "作者", -1))
const _hoisted_9 = { class: "option-unchangeable" }
const _hoisted_10 = { class: "option" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-name" }, "場所", -1))
const _hoisted_12 = { class: "option-unchangeable" }
const _hoisted_13 = { class: "option" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-name" }, "表示名", -1))
const _hoisted_15 = {
  ref: "engineNameInput",
  class: "option-value-text",
  type: "text",
  name: "ElectronShogiEngineName"
}
const _hoisted_16 = { class: "option-name" }
const _hoisted_17 = ["id", "min", "max", "name"]
const _hoisted_18 = ["id", "name"]
const _hoisted_19 = ["id", "name"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["id"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "既定値", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "true" }, "ON", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "false" }, "OFF", -1))
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = ["id"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "既定値", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "dialog-main-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("dialog", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.engine.defaultName), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.engine.author), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.engine.path), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("input", _hoisted_15, null, 512)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            key: option.name,
            class: "option"
          }, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(option.name), 1),
            (option.type === 'spin')
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  id: option.inputId,
                  class: "option-value-number",
                  type: "number",
                  min: option.min,
                  max: option.max,
                  step: "1",
                  name: option.name
                }, null, 8, _hoisted_17))
              : _createCommentVNode("", true),
            (option.type === 'string')
              ? (_openBlock(), _createElementBlock("input", {
                  key: 1,
                  id: option.inputId,
                  class: "option-value-text",
                  type: "text",
                  name: option.name
                }, null, 8, _hoisted_18))
              : _createCommentVNode("", true),
            (option.type === 'filename')
              ? (_openBlock(), _createElementBlock("input", {
                  key: 2,
                  id: option.inputId,
                  class: "option-value-filename",
                  type: "text",
                  name: option.name
                }, null, 8, _hoisted_19))
              : _createCommentVNode("", true),
            (option.type === 'filename')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "dialog-button",
                  onClick: ($event: any) => (_ctx.selectFile(option.inputId))
                }, " 選択 ", 8, _hoisted_20))
              : _createCommentVNode("", true),
            (option.type === 'check')
              ? (_openBlock(), _createElementBlock("select", {
                  key: 4,
                  id: option.inputId,
                  class: "option-value-check"
                }, _hoisted_25, 8, _hoisted_21))
              : _createCommentVNode("", true),
            (option.type === 'combo')
              ? (_openBlock(), _createElementBlock("select", {
                  key: 5,
                  id: option.inputId,
                  class: "option-value-combo"
                }, [
                  _hoisted_27,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.vars, (v) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: v,
                      value: v
                    }, _toDisplayString(v), 9, _hoisted_28))
                  }), 128))
                ], 8, _hoisted_26))
              : _createCommentVNode("", true),
            (option.type === 'button')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 6,
                  class: "dialog-button",
                  onClick: ($event: any) => (_ctx.sendOption(option.name))
                }, " 実行 ", 8, _hoisted_29))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("button", {
        class: "dialog-wide-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reset()))
      }, " エンジンの既定値に戻す "),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ok()))
        }, "OK"),
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
        }, "キャンセル")
      ])
    ], 512)
  ]))
}